import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    container: {
      flexGrow: 1,
      // width: '100vw', // Removed by JT due to new parent flex element
      height: 'calc(100vh - 60px)', // JT was wrong - this is needed :)
      // background: 'rgba(0, 0, 0, 0.2)', // Removed by JT as it should just use the page background
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
  { name: 'LoadingScreen' },
);

const LoadingScreen: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div id="jumpingDotLoader">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

export default LoadingScreen;
